/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import type Router from '@ember/routing/router-service';
import type CommonPrimaryNavBarService from 'embercom/services/common-primary-nav-bar-service';

export default class KnowledgeHubController extends Controller {
  queryParams = [];

  @service declare appService: $TSFixMe;
  @service declare navbarCollapsingService: $TSFixMe;
  @service declare router: Router;
  @service declare commonPrimaryNavBarService: CommonPrimaryNavBarService;
  @service declare helpCenterService: any;

  get defaultHelpCenterId() {
    return this.helpCenterService.allSites.firstObject.id;
  }

  get appId() {
    return this.appService.app.id;
  }

  get numOfHelpCenterSites() {
    return this.helpCenterService.allSites.length;
  }

  get goToHelpCenterRoute() {
    if (this.numOfHelpCenterSites === 1) {
      return 'apps.app.settings.helpcenter.workspace-helpcenter.collections';
    }
    return 'apps.app.settings.helpcenter.all';
  }

  get submenuCollapsed() {
    return this.navbarCollapsingService.collapsed || this.appService.app.canUseStandalone;
  }
}
